var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3023_978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5C3.08695 5 2.45107 5.2634 1.98223 5.73223C1.51339 6.20108 1.25 6.83695 1.25 7.5V31.25C1.25 31.913 1.51339 32.549 1.98223 33.0177C2.45107 33.4865 3.08695 33.75 3.75 33.75H31.25C31.913 33.75 32.549 33.4865 33.0177 33.0177C33.4865 32.549 33.75 31.913 33.75 31.25V7.5C33.75 6.83695 33.4865 6.20108 33.0177 5.73223C32.549 5.2634 31.913 5 31.25 5H26.25",
    stroke: "#1C2A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1.25V8.75",
    stroke: "#1C2A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 1.25V8.75",
    stroke: "#1C2A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5H21.25",
    stroke: "#1C2A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 16.25C9.44035 16.25 10 15.6904 10 15C10 14.3096 9.44035 13.75 8.75 13.75C8.05965 13.75 7.5 14.3096 7.5 15C7.5 15.6904 8.05965 16.25 8.75 16.25Z",
    stroke: "#1C2A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.25C18.1904 16.25 18.75 15.6904 18.75 15C18.75 14.3096 18.1904 13.75 17.5 13.75C16.8096 13.75 16.25 14.3096 16.25 15C16.25 15.6904 16.8096 16.25 17.5 16.25Z",
    stroke: "#1C2A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 16.25C26.9403 16.25 27.5 15.6904 27.5 15C27.5 14.3096 26.9403 13.75 26.25 13.75C25.5597 13.75 25 14.3096 25 15C25 15.6904 25.5597 16.25 26.25 16.25Z",
    stroke: "#1C2A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 26.25C9.44035 26.25 10 25.6903 10 25C10 24.3096 9.44035 23.75 8.75 23.75C8.05965 23.75 7.5 24.3096 7.5 25C7.5 25.6903 8.05965 26.25 8.75 26.25Z",
    stroke: "#1C2A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 26.25C18.1904 26.25 18.75 25.6903 18.75 25C18.75 24.3096 18.1904 23.75 17.5 23.75C16.8096 23.75 16.25 24.3096 16.25 25C16.25 25.6903 16.8096 26.25 17.5 26.25Z",
    stroke: "#1C2A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3023_978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaricon);
export default __webpack_public_path__ + "static/media/calendar icon.e2c07005a2b2b290c61efb69307e8a0f.svg";
export { ForwardRef as ReactComponent };